<div class="popup">
  <h3 mat-dialog-title>Listo para despachar #3446</h3>
  <mat-form-field appearance="outline">
    <mat-label>Seleccionar opción de envío</mat-label>
    <mat-select disableRipple>
      <mat-option value="1">Option 1</mat-option>
      <mat-option value="2">Option 2</mat-option>
      <mat-option value="3">Option 3</mat-option>
    </mat-select>
  </mat-form-field>
  <div mat-dialog-actions fxLayout="column" fxLayoutAlign="space-between end" >
    <button mat-button class="btnEnviar">Enviar Pedido</button>
    <button mat-button mat-dialog-close class="btnCerrar">Cerrar</button>
  </div>
</div>